<template>
  <div class="home" :class="[colorTheme]">
    <v-app id="inspire">
      <NavDrawer/>
      <AppBar/>
      <RestaurantOrderHistory/>
      <Footer/>
    </v-app>
  </div>
</template>

<script>
// @ is an alias to /src

import HeaderBar from '@/components/HeaderBar.vue'
import NavDrawer from '@/components/NavDrawer.vue'
import AppBar from '@/components/AppBar.vue'
import Footer from '@/components/Footer.vue'
import RestaurantOrderHistory from '@/components/RestaurantOrderHistory.vue'

export default {

  components: {
    RestaurantOrderHistory,
    NavDrawer,
    AppBar,
    Footer
  },
  data: () => ({
    drawer: null
  }),
  computed:{
    colorTheme: function () {
      return this.$store.state.shop.color_theme;
    },
  }
}
</script>
